module.exports = __webpack_public_path__ + "static/media/sUSD-logo.a7493658.png";